import { render, staticRenderFns } from "./activePage.vue?vue&type=template&id=16c7f2ce&scoped=true&"
import script from "./activePage.vue?vue&type=script&lang=js&"
export * from "./activePage.vue?vue&type=script&lang=js&"
import style0 from "./activePage.vue?vue&type=style&index=0&id=16c7f2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7f2ce",
  null
  
)

export default component.exports